import { MenuItem } from '@mui/material';
import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ControlledInput, ControlledSelect, FormGrid, Section } from '../../../shared';
import { useOrganisationTypeList } from '../../hooks/organisation-type.hook';

export const OrganisationDataInputs: FC = () => {
    const { t } = useTranslation();

    const { data: organisationTypesData } = useOrganisationTypeList({
        page: 1,
        pageSize: 100,
        sortBy: 'name',
        sortOrder: 'ASC',
    });

    const organisationTypes = useMemo(() => organisationTypesData?.data || [], [organisationTypesData]);

    return (
        <Section title={t('data')}>
            <FormGrid size={{ xs: 3 }}>
                <ControlledInput name="name" label={t('nameLabel')} required />
                <ControlledSelect name={'type'} label={t('typeLabel')} required>
                    {organisationTypes.map((type) => (
                        <MenuItem key={type.id} value={type.id}>
                            {type.name}
                        </MenuItem>
                    ))}
                </ControlledSelect>
            </FormGrid>
        </Section>
    );
};
